import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id D513E54E-6492-4C2A-99E9-3E50C5662B88
 * name gamepad-right
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-right.svg
 * tags
 * - Gaming / RPG 
 */
export const GamepadRightIcon = createSvgIcon(<><path d="M9,2V7.5L12,10.5L15,7.5V2H9M2,9V15H7.5L10.5,12L7.5,9H2M16.5,9L13.5,12L16.5,15H22V9H16.5M18,11H20V13H18V11M12,13.5L9,16.5V22H15V16.5L12,13.5Z" /></>, 'GamepadRightIcon');
export default GamepadRightIcon